/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxDateTimeInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdatetimeinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcDateTimeInputComponent),
    multi: true
};

/**
 * Date Time Input
 */

export class NgcDateTimeInputComponent extends ControlComponent {
     animationType: any;
     allowNullDate: any;
     allowKeyboardDelete: any;
     clearString: any;
     culture: any;
     closeDelay: any;
     closeCalendarAfterSelection: any;
     dropDownHorizontalAlignment: any;
     dropDownVerticalAlignment: any;
     enableBrowserBoundsDetection: any;
     enableAbsoluteSelection: any;
     firstDayOfWeek: any;
     formatString: any;
     min: any;
     max: any;
     openDelay: any;
     placeHolder: any;
     popupZIndex: any;
     rtl: any;
     readonly: any;
     showFooter: any;
     selectionMode: any;
     showWeekNumbers: any;
     showTimeButton: any;
     showCalendarButton: any;
     theme: any;
     template: any;
     textAlign: any;
     todayString: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-datetimeinput',
    template: `<jqxDateTimeInput *ngIf="visible" (onChange)="inputChange($event)"
                [animationType] = "animationType"
                [allowNullDate] = "allowNullDate"
                [allowKeyboardDelete] = "allowKeyboardDelete"
                [clearString] = "clearString"
                [culture] = "culture"
                [closeDelay] = "closeDelay"
                [closeCalendarAfterSelection] = "closeCalendarAfterSelection"
                [dropDownHorizontalAlignment] = "dropDownHorizontalAlignment"
                [dropDownVerticalAlignment] = "dropDownVerticalAlignment"
                [disabled] = "disabled"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [enableAbsoluteSelection] = "enableAbsoluteSelection"
                [firstDayOfWeek] = "firstDayOfWeek"
                [formatString] = "formatString"
                [min] = "min"
                [max] = "max"
                [openDelay] = "openDelay"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [rtl] = "rtl"
                [readonly] = "readonly"
                [showFooter] = "showFooter"
                [selectionMode] = "selectionMode"
                [showWeekNumbers] = "showWeekNumbers"
                [showTimeButton] = "showTimeButton"
                [showCalendarButton] = "showCalendarButton"
                [theme] = "theme"
                [template] = "template"
                [textAlign] = "textAlign"
                [todayString] = "todayString"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                </jqxDateTimeInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animationType': [{ type: Input, args: ['animationType', ] },],
'allowNullDate': [{ type: Input, args: ['allowNullDate', ] },],
'allowKeyboardDelete': [{ type: Input, args: ['allowKeyboardDelete', ] },],
'clearString': [{ type: Input, args: ['clearString', ] },],
'culture': [{ type: Input, args: ['culture', ] },],
'closeDelay': [{ type: Input, args: ['closeDelay', ] },],
'closeCalendarAfterSelection': [{ type: Input, args: ['closeCalendarAfterSelection', ] },],
'dropDownHorizontalAlignment': [{ type: Input, args: ['dropDownHorizontalAlignment', ] },],
'dropDownVerticalAlignment': [{ type: Input, args: ['dropDownVerticalAlignment', ] },],
'enableBrowserBoundsDetection': [{ type: Input, args: ['enableBrowserBoundsDetection', ] },],
'enableAbsoluteSelection': [{ type: Input, args: ['enableAbsoluteSelection', ] },],
'firstDayOfWeek': [{ type: Input, args: ['firstDayOfWeek', ] },],
'formatString': [{ type: Input, args: ['formatString', ] },],
'min': [{ type: Input, args: ['min', ] },],
'max': [{ type: Input, args: ['max', ] },],
'openDelay': [{ type: Input, args: ['openDelay', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'popupZIndex': [{ type: Input, args: ['popupZIndex', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'readonly': [{ type: Input, args: ['readonly', ] },],
'showFooter': [{ type: Input, args: ['showFooter', ] },],
'selectionMode': [{ type: Input, args: ['selectionMode', ] },],
'showWeekNumbers': [{ type: Input, args: ['showWeekNumbers', ] },],
'showTimeButton': [{ type: Input, args: ['showTimeButton', ] },],
'showCalendarButton': [{ type: Input, args: ['showCalendarButton', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'template': [{ type: Input, args: ['template', ] },],
'textAlign': [{ type: Input, args: ['textAlign', ] },],
'todayString': [{ type: Input, args: ['todayString', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Date Time Input Module
 */

export class NgcDateTimeInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcErrorModule],
    exports: [NgcDateTimeInputComponent],
    declarations: [NgcDateTimeInputComponent, jqxDateTimeInputComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
